export default __webpack_public_path__ + "static/media/share-x-icon.06c6c40d.png";